import { RootState } from "@store";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";

const createMinersSelector = () => (state: RootState) =>
  state.storedMiners.Miners;

export const useStoredMiners = () => {
  const selector = createMinersSelector();
  const reselect = createSelector(selector, (miners) => miners);
  return useSelector(reselect) || [];
};

const createTotalsSelector = () => (state: RootState) =>
  state.storedMiners.Total;

export const useStoredMinerTotal = () => {
  const selector = createTotalsSelector();
  const reselect = createSelector(selector, (total) => total);
  return useSelector(reselect);
};

const createRefSelector = () => (state: RootState) => {
  return state.storedMiners.isRefreshing;
};

export const useRefreshingStoredMiners = () => {
  const selector = createRefSelector();
  const reselect = createSelector(selector, (b) => {
    return b;
  });
  return useSelector(reselect);
};
